import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { Size } from './types';
interface LogoContainerProps {
  size?: Size;
  children: React.ReactNode;
}
export const LogoContainer = t0 => {
  const $ = _c(8);
  const {
    size,
    children
  } = t0;
  const t1 = size === 40;
  const t2 = size === 50;
  const t3 = size === 60;
  const t4 = size === 80;
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = cn("flex shrink-0 items-center justify-start pt-4", {
      "size-40": t1,
      "size-50": t2,
      "size-60": t3,
      "size-80": t4
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[5] = children;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};